import { render } from "./SingleQuestion.vue?vue&type=template&id=4c8c3938"
import script from "./SingleQuestion.vue?vue&type=script&lang=js"
export * from "./SingleQuestion.vue?vue&type=script&lang=js"

import "./SingleQuestion.vue?vue&type=style&index=0&id=4c8c3938&lang=css"

import exportComponent from "/Users/robert.bryden/Documents/GitHub/BreakOutTheBox/webappV2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__